var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C27.165 0 35 7.835 35 17.5S27.165 35 17.5 35 0 27.165 0 17.5 7.835 0 17.5 0z",
    fill: "#394149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.252 11.375c-.139 0-.252.106-.252.237v.229l10.5 7.462L28 12.07v-.458c0-.131-.113-.237-.252-.237H7.252zM7 13.017v9.555l6.066-5.244L7 13.017zm21 .222l-6.005 4.134L28 22.572v-9.333zm-14.132 4.659l-6.135 5.31h19.534l-6.081-5.273-3.404 2.344a.501.501 0 0 1-.572-.007l-3.342-2.374z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.07ddcefd5eb3319ff4a4c1e34678a591.svg";
export { ForwardRef as ReactComponent };